import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useWxWork } from '@cloud/wxwork-workbench';
import Drawer from '@/components/Drawer';
import { defaultAvatarUrl } from '@/constants';
import { CustomerDetailItem, queryCustomerDetail } from './service';
import styles from './index.less';


const RecordDrawer: FC<{ id: string | void, onClose: () => void }> = ({ id, onClose }) => {
  const [list, setList] = useState<CustomerDetailItem[]>([]);
  const signature = useWxWork();

  useEffect(() => {
    if ('WWOpenData' in window) {
      WWOpenData.bindAll(document.querySelectorAll('ww-open-data'));
    }
  });

  useEffect(() => {
    if (id) {
      queryCustomerDetail(id, signature).then(res => {
        setList([...res]);
      });
    }
  }, [id, signature]);

  useEffect(() => {
    if (!id) {
      setList([]);
    }
  }, [id]);

  return (
    <Drawer title='分配记录' visible={!!id} onClose={onClose}>
      <ul className={styles.recordList}>
        {list.map(({ userId, allocationDate, avatar }, i) => (
          <li key={i} className={styles.item}>
            <div className={styles.wrapper}>
              <span className={classNames(styles.avatar, { [styles.default]: !avatar })} style={{ backgroundImage: `url(${avatar || defaultAvatarUrl})` }} />
              <div className={styles.content}>
                <span className={styles.name} dangerouslySetInnerHTML={{
                  __html: `<ww-open-data corpid=${signature.corpId} type='userName' openid=${userId}></ww-open-data>`
                }} />
                <span className={styles.time}>分配时间：{allocationDate}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Drawer>
  )
}

export default RecordDrawer;